<template>
  <div class="managedevices">
    <!-- notification display -->
    <vk-notification
      position="top-right"
      :messages.sync="notifications"
    ></vk-notification>

    <!-- device archival modal -->
    <vk-modal :show.sync="confirmArchive">
      <vk-modal-title>Archiviazione device</vk-modal-title>
      <p>
        <b>ATTENZIONE</b>
        Il device "<b>{{ archivingDeviceLabel }}</b>" (<span class="device-id">{{ archivingDeviceID }}</span>) sta per essere archiviato.
        Non sarà più visibile ad alcun utente, insieme ai suoi dati. Potrà essere reso nuovamente visibile <b>solo</b> se invierà ancora dati al server, altrimenti rimarrà nel limbo!

        (nel caso in cui dovesse tornare visibile, tutti i dati precedenti saranno presenti - cioè l'archiviazione non comporta una perdita dei dati precedenti, ma va comunque usata con cautela)
      </p>
      <p>
        Assicurarsi di voler effettivamente portare a termine questa operazione
      </p>
      <p class="uk-text-right">
        <vk-button @click="doArchive">Archivia</vk-button>
        <vk-button @click="confirmArchive = false" type="primary">Annulla</vk-button>
      </p>
    </vk-modal>

    <!-- user associations modal -->
    <vk-modal :show.sync="associationModalOpen">
      <vk-modal-title>Associazione device</vk-modal-title>
      <div class="uk-overflow-auto user-list">
        <table class="uk-table uk-table-striped uk-table-small">
          <thead>
            <tr>
              <th></th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in nonAdminUsers" v-bind:key="user.email">
              <td>
                <input class="uk-checkbox" type="checkbox" v-if="associations[associationDeviceID] != null && associations[associationDeviceID][user.email] != null" v-model="associations[associationDeviceID][user.email]">
              </td>
              <td>{{ user.email }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="uk-text-right">
        <vk-button @click="setAssociation">Modifica</vk-button>
        <vk-button @click="associationModalOpen = false" type="primary">Annulla</vk-button>
      </p>
    </vk-modal>

    <vk-card>
      <h1>Gestione devices</h1>
      <vk-button type="secondary" @click="updateList"><vk-icon icon="refresh"></vk-icon> Aggiorna</vk-button>
      <p>Assegnazione di device ad utenti (che potranno quindi visualizzarne i dati raccolti)</p>
      <p>E' sufficiente usare la dropdown a destra di ogni voce della tabella per assegnare un dispositivo ad un certo utente. Il cambiamento è immediato. E' inoltre possibile assegnare un etichetta (un nome arbitrario) ai device per distinguerli più facilmente. L'etichetta viene aggiornata quando la casella di testo perde il focus (basta cliccare altrove per deselezionarla).</p>

      <vk-table :data="devices" striped hoverable>
        <vk-table-column title="Etichetta" cell="id">
          <div slot-scope="{ cell }">
            <input class="uk-input uk-form-width-medium" v-model="labels[cell]" v-on:blur="updateDeviceLabel(cell)" type="text" placeholder="Etichetta">
          </div>
        </vk-table-column>
        <vk-table-column title="ID" cell="id">
          <div slot-scope="{ cell }">
            <span class="device-id">{{ cell.substr(0, 12) }}</span>
          </div>
        </vk-table-column>
        <vk-table-column title="Primo record" cell="firstUpdate"></vk-table-column>
        <vk-table-column title="Ultimo record" cell="lastUpdate"></vk-table-column>
        <vk-table-column title="Ultima posizione" cell="coord">
          <div slot-scope="{ cell }">
            <a target="_blank" rel="noopener noreferrer" :href='"http://www.google.com/maps/place/" + cell[0] + "," + cell[1]'>{{cell[0]}}, {{cell[1]}}</a>
          </div>
        </vk-table-column>
        <vk-table-column title="Utenti assegnati" cell="id">
          <div slot-scope="{ cell }">
            <div class="uk-button-group">
              <button class="uk-button uk-button-default" disabled>{{ associations[cell] != null ? Object.values(associations[cell]).filter(a => a).length : 0 }}</button>
              <button class="uk-button uk-button-secondary" @click="openAssociationModal(cell)">modifica...</button>
            </div>
          </div>
        </vk-table-column>
        <vk-table-column title="Archivia" cell="id">
          <div slot-scope="{ cell }">
            <vk-button type="danger" v-on:click="beginArchive(cell)"><vk-icon icon="trash"></vk-icon></vk-button>
          </div>
        </vk-table-column>
      </vk-table>
      <h1>Devices archiviati</h1>
      <vk-table :data="archivedDevices" striped hoverable narrowed>
        <vk-table-column title="Etichetta" cell="label">
          <div slot-scope="{ cell }">
            <b>{{ cell }}</b>
          </div>
        </vk-table-column>
        <vk-table-column title="ID" cell="id">
          <div slot-scope="{ cell }">
            <span class="device-id">{{ cell }}</span>
          </div>
        </vk-table-column>
      </vk-table>
    </vk-card>
  </div>
</template>

<style lang="scss">
  .device-id {
    font-family: monospace;
    font-size: 0.8em;
  }

  .user-list {
    max-height: 35em;
  }
</style>

<script>
import config from '@/config'
import { timestampToReadable } from '@/utils'

export default {
  name: 'managedevices',
  
  components: {},

  data () {
    return {
      users: [],
      
      devices: [],
      archivedDevices: [],

      associations: {},
      labels: {},

      notifications: [],

      confirmArchive: false,
      archivingDeviceID: "",
      archivingDeviceLabel: "",

      associationModalOpen: false,
      associationDeviceID: "",
    }
  },

  created () {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
      return
    }

    if (!this.$store.state.isAdmin) {
      this.$router.push('/')
      return
    }

    this.updateList()
  },

  computed: {
    nonAdminUsers () {
      return this.users.filter(u => u.isAdmin == false)
    }
  },
  
  methods: {
    async updateList () {
      this.$store.dispatch('REFRESH_USER_DEVICES', this.$http)

      try {
        const headers = { Authorization: 'Bearer ' + localStorage.getItem('token') }

        const [usersR, devicesR, associationsR] = await Promise.all([
          this.$http.get(config.API_URL + '/allUsers', { headers: headers }),
          this.$http.get(config.API_URL + '/allDevices', { headers: headers }),
          this.$http.get(config.API_URL + '/allDevicesAssociations', { headers: headers })
        ])

        this.users = usersR.body == null ? [] : usersR.body.map(user => { return { email: user.email, isAdmin: user.isAdmin } })
        this.devices = devicesR.body == null ? [] : devicesR.body.map(device => {
          return {
            id: device.id,
            label: device.label,
            coord: [device.lastLat, device.lastLon],
            firstUpdate: timestampToReadable(device.firstUpdate),
            lastUpdate: timestampToReadable(device.lastUpdate)
          }
        })

        let newLabels = {}
        if (devicesR.body != null) {
          devicesR.body.forEach(device => {
            newLabels[device.id] = device.label
          })
        }
        this.labels = newLabels

        let newAssociations = {}
        if (associationsR.body != null) {
          Object.keys(associationsR.body).forEach(device => {
            newAssociations[device] = {}

            const associatedUsers = associationsR.body[device]
            this.users.forEach(user => {
              newAssociations[device][user.email] = associatedUsers.includes(user.email)
            })
          })
        }
        this.associations = newAssociations

        const archivedDevicesR = await this.$http.get(config.API_URL + '/archivedDevices', { headers: headers })

        this.archivedDevices = archivedDevicesR.body == null ? [] : archivedDevicesR.body.map(device => {
          return {
            id: device.id,
            label: device.label
          }
        })
      } catch (err) {
        console.log(err)
        this.$store.commit('LOGOUT_USER')
        localStorage.removeItem('token')
        this.$router.push('/login')
      }
    },

    updateDeviceLabel (id) {
      const newLabel = this.labels[id]
      const previousLabel = this.devices.filter((device) => {return device.id == id})[0].label;
      
      if (newLabel == previousLabel) {
        return
      }

      let formData = new FormData()
      formData.append("label", newLabel)
      formData.append("deviceID", id)

      this.$http.post(config.API_URL + '/setDeviceLabel', formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        () => {
          const message = 'Etichetta modificata (' + id.substr(0, 12) + ': "' + newLabel + '")'
          this.notifications.push({ message: message, status: 'success' })
          this.updateList()
        }, (err) => {
          console.log(err)
          this.notifications.push({ message: 'Errore nella modifica etichetta', status: 'danger' })
          this.updateList()
        }
      )
    },

    beginArchive (deviceID) {
      this.archivingDeviceID = deviceID
      this.archivingDeviceLabel = this.labels[deviceID]
      this.confirmArchive = true
    },

    doArchive () {
      this.confirmArchive = false
      this.archiveDevice(this.archivingDeviceID)
    },

    archiveDevice (device) {
      let formData = new FormData()
      formData.append("deviceID", device)
      formData.append("archived", 1)

      this.$http.post(config.API_URL + '/setDeviceArchived', formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        () => {
          let message = "Archiviazione completata (" + device + ")";
          this.notifications.push({ message: message, status: 'success' })
          this.updateList()
        }, (err) => {
          console.log(err)
          this.notifications.push({ message: 'Archiviazione non riuscita', status: 'danger' })
          this.updateList()
        }
      )
    },

    openAssociationModal (device) {
      this.associationDeviceID = device
      this.associationModalOpen = true
    },

    async setAssociation () {
      const deviceID = this.associationDeviceID

      const users = Object.entries(this.associations[deviceID]).filter(a => a[1]).map(a => a[0])

      try {
        await this.$http.post(config.API_URL + '/setDeviceAssociations', {
          deviceID: deviceID,
          users: users
        }, {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        })
        
        let message = "Assegnazione device modificata (" + deviceID + ")"
        this.notifications.push({ message: message, status: 'success' })
        this.updateList()
        this.associationModalOpen = false
      } catch (err) {
        console.log(err)
        this.notifications.push({ message: 'Assegnazione non riuscita', status: 'danger' })
        this.updateList()
        this.associationModalOpen = false
      }
    }
  }
}
</script>
